import { useEffect } from 'react'

import type { Subscribable } from '../openlayers/CallbackRegistry'

/** Listen on one of a map instance's click channels for the life of the component. */
export const useMapListener = <T>(
  channel: Subscribable<T>,
  listener: (payload: T) => void
): void => {
  useEffect(() => channel.on(listener), [channel, listener])
}
